import { Component, OnInit } from '@angular/core';
import {IonModal} from "@ionic/angular";
import {WasteService} from "../../service/waste.service";

@Component({
  selector: 'app-waste-settings',
  templateUrl: './waste-settings.component.html',
  styleUrls: ['./waste-settings.component.scss']
})
export class WasteSettingsComponent  implements OnInit {

  trovaZonaModal: IonModal;
  rifiutiIngombrantiModal: IonModal;

  constructor(public wasteService:  WasteService) { }

  ngOnInit() {}

}
